import LoadingOverlay from '~/core/ui/LoadingOverlay'

/**
 * @name PageLoadingIndicator
 * @deprecated
 * This component is deprecated. Please use LoadingOverlay instead.
 */
const PageLoadingIndicator = LoadingOverlay

export default PageLoadingIndicator
